import { useState, useCallback } from 'react';
import { AlertColor } from '@mui/material';

interface ToastState {
  open: boolean;
  message: string;
  severity?: AlertColor;
}

const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: '',
    severity: undefined,
  });

  const showToast = useCallback((message: string, severity?: AlertColor) => {
    setToast({
      open: true,
      message,
      severity,
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast({
      open: false,
      message: '',
      severity: undefined,
    });
  }, []);

  return {
    toast,
    showToast,
    hideToast,
  };
};

export default useToast;
